import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchLearnMoreAction = createDataModuleActions('FETCH_LEARN_MORE');
export const fetchLearnMore = fetchLearnMoreAction.dataRequest;
export const fetchLearnMoreSuccess = fetchLearnMoreAction.dataSuccess;
export const fetchLearnMoreError = fetchLearnMoreAction.dataError;
export const fetchLearnMoreReset = fetchLearnMoreAction.dataReset;
